<template>
    <div>
      <!-- Entities list -->
        <div class="row">
            <!-- Loading indicator -->
            <div v-if="loading || entities.length === 0" class="col-12 text-center py-5">
              <span>Loading...</span>
            </div>
            
            <div v-else class="col-6 col-sm-4 col-md-3 mb-4" v-for="entity in entities" :key="entity.id">
                <div class="flag-card text-center p-3">
                    <div class="flag-card__image p-1 mb-lg-3 mb-2">
                        <img :src="entity.image" :alt="entity.title" class="img-fluid" />
                    </div>
                    <div class="flag-card__title mb-lg-3 mb-2">{{ entity.title }}</div>
                    <button class="btn btn-select w-100" @click="openModal(entity)">Select</button>
                </div>
            </div>
        </div>

  
      <!-- Applicant Count Modal -->
      <div class="modal fade" id="applicantModal" tabindex="-1" aria-labelledby="applicantModalLabel" aria-hidden="true" ref="modal">
        <div class="modal-dialog modal-dialog-centered modal-small">
          <div class="modal-content text-center">
            <div class="modal-body">
              <img
                :src="selectedEntity.image"
                alt="Country Flag"
                class="img-fluid"
                v-if="selectedEntity"
              />
              <h5 class="my-4">
                How many applicants for
                <span>{{ selectedEntity.title }}</span>?
              </h5>
              <div class="btn-group mb-4" role="group" aria-label="Applicant count">
                <button
                  v-for="n in 5"
                  :key="n"
                  type="button"
                  class="applicant-btn"
                  :class="{ active: selectedApplicantCount === n }"
                  @click="selectApplicantCount(n)"
                >
                  {{ n }}
                </button>
              </div>
              <div class="d-flex justify-content-between gap-3">
                <button class="btn btn-cancel w-50" data-bs-dismiss="modal">Cancel</button>
                <button class="btn btn-next w-50" @click="showInstructionModal" :disabled="!selectedApplicantCount">Next</button>
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Instruction Modal -->
      <div class="modal fade" id="instructionModal" tabindex="-1" aria-labelledby="instructionModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content p-4 rounded-4">
            <div class="modal-header border-0 pb-0">
              <h5 class="modal-title fw-semibold" id="instructionModalLabel">
                Document Required for Visa Medical
              </h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body text-start pt-1">
              <p class="text-danger fw-semibold mb-3">
                Keep following documents handy before proceeding next:
              </p>

              <div v-if="selectedInstructions && selectedInstructions.length" class="instruction-scroll">
              <div v-html="cleanInstructions" class="word-break"></div>
            </div>


              <p v-else class="text-muted">No instructions available for this country.</p>

              <div class="d-flex justify-content-between gap-2 mt-4">
                <button
                  type="button"
                  class="btn btn-cancel w-50"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <a
                  :href="`/bookAppointment/${selectedEntity.id}?applicants=${selectedApplicantCount}`"
                  class="btn btn-next w-50"
                >
                  Next
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { GetEntities } from '@/api/Front/home';
  import { useEntityStore } from '@/store/entities';
  export default {
    name: 'Entity',
    computed: {
      truncatedInstructions() {
        const words = this.selectedInstructions.split(' ');
        if (words.length <= 50) return this.selectedInstructions;
        return words.slice(0, 50).join(' ') + '...';
      },
      cleanInstructions() {
        if (!this.selectedInstructions) return '';

        // Create a temporary DOM element
        const temp = document.createElement('div');
        temp.innerHTML = this.selectedInstructions;

        // Remove empty <p> tags
        const paragraphs = temp.querySelectorAll('p');
        paragraphs.forEach(p => {
          if (!p.textContent.trim()) p.remove();
        });

        return temp.innerHTML;
      }
    },
    data() {
      return {
        entities: [],
        selectedEntity: {},
        selectedApplicantCount: null,
        selectedInstructions: '',
        showFullInstructions: false,
        isOverflow: false,
        loading: true,
      };
    },
    mounted() {
      this.loadEntities();
    },
    methods: {
      async loadEntities() {
        try {
          this.loading = true;
          const response = await GetEntities();
          this.entities = response.data.data;
        } catch (error) {
          console.error('Failed to fetch entities:', error);
        } finally {
          this.loading = false; 
        }
      },
      openModal(entity) {
        this.selectedEntity = entity;
        this.selectedApplicantCount = null; 
        const modal = new bootstrap.Modal(this.$refs.modal);
        modal.show();
      },
      selectApplicantCount(count) {
        this.selectedApplicantCount = count;
      },
      showInstructionModal() {
        if (!this.selectedApplicantCount) {
          alert('Please select the number of applicants.');
          return;
        }
  
        const applicantModal = bootstrap.Modal.getInstance(this.$refs.modal);
        if (applicantModal) applicantModal.hide();
  
        //const country = this.selectedEntity.title;
        const entity = this.selectedEntity;
        if (entity.entity_instruction) {
          // Split by the bullet "•" and filter out empty strings
          this.selectedInstructions = entity.entity_instruction;
        } else {
          this.selectedInstructions = [];
        }

  
        setTimeout(() => {
          const instructionModal = new bootstrap.Modal(
            document.getElementById('instructionModal')
          );
          instructionModal.show();
        }, 300);
      },
      toggleInstructions() {
        this.showFullInstructions = !this.showFullInstructions;
      },
    },
  };
  </script>
  
  <style>
  .applicant-btn {
    margin: 0 5px;
    padding: 0.5rem 1rem;
    cursor: pointer;
    border: 1px solid #007bff;
    background-color: white;
    color: #007bff;
    border-radius: 4px;
  }
  .applicant-btn.active {
    background-color: #007bff;
    color: white;
  }
  .word-break {
    word-wrap: break-word;   /* For older browsers */
    overflow-wrap: break-word; /* Modern standard */
    word-break: break-word;    /* Force breaking long words */
  }

  .instruction-scroll {
    max-height: 300px; /* approx. 200 words height */
    overflow-y: auto;
    padding-right: 10px; /* avoid scrollbar overlapping text */
    /* Fix for mobile scrolling */
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
  }

  </style>
  